export var TITLE = '14px';
export var NORMAL = '12px';
export var SMALL = '11px';